import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';
import * as utils from '../../utils/utils';

export const fetchTitleInfo = (type, id) => {
  return dispatch => {
    return dispatch({
      type: actionsTypes.FETCH_TITLE_INFO,
      payload: Promise.all([
        API.fetch_reviews(type, id),
        API.fetch_title_trailers(type, id),
        API.fetch_credits(type, id),
        API.fetch_details(type, id),
      ]).then(data => {
        return utils.reduceTitles(data);
      }),
    });
  };
};
